import PropTypes from 'prop-types';
import Image from 'next/image';
import { Box, Typography } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import imageDefault from 'public/assets/images/default-fallback-image.png';

import { PersonShape } from 'components/HomeComponents/Testimonies/props';

import * as Styles from './styles';

Testimony.propTypes = {
  handleDialog: PropTypes.func.isRequired,
  config: PropTypes.shape({
    quoteColor: PropTypes.string,
    wrapperColor: PropTypes.string,
  }).isRequired,
  person: PersonShape.isRequired,
};

export default function Testimony({ person, config, handleDialog }) {
  return (
    <Box sx={Styles.Wrapper(config.wrapperColor)}>
      <Box
        sx={Styles.ImageWrapper}
        onClick={() => {
          handleDialog(person);
        }}
      >
        <Box sx={Styles.PlayIconWrapper}>
          <PlayArrowIcon />
        </Box>

        <Image
          src={person.thumbURL ? person.thumbURL : imageDefault}
          loader={({ src, width }) => `${src}?w=${width}`}
          alt={`${person.name} depoimento`}
          fill
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
          style={{ objectFit: 'cover' }}
        />
      </Box>

      <Box px={3} pt={4} pb={3}>
        <Box minHeight={{ xs: 'auto', md: '320px' }}>
          <Box component="span" sx={Styles.Quote(config.quoteColor)}>
            &ldquo;
          </Box>

          <Typography variant="body1" fontStyle="italic">
            {person.text}
          </Typography>

          <Box
            component="span"
            sx={Styles.Quote(config.quoteColor)}
            textAlign="right"
          >
            &rdquo;
          </Box>
        </Box>

        <Box>
          <Typography variant="body1" fontWeight={700}>
            {person.name}
          </Typography>

          <Typography variant="body2">{person.product}</Typography>
        </Box>
      </Box>
    </Box>
  );
}
